import Vue from "vue";
import CompanyService from "@/service/CompanyService";
import MenuRightSerivce from "@/service/MenuRightService";
import SweetAlertService from "@/service/SweetAlertService";
import StaffService from "@/service/StaffService";
import StaffEmploymentService from "@/service/StaffEmploymentService";
import StoreGetter from "@/constants/StoreGetter";
import { EmployStatus } from "@/model/EmployStatus";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import Setting from "@/constants/Settings";
import EmployStatusValidation from "./S081700-EmployStatusValidation.js";
import Paginate from "vuejs-paginate";
var EmployStatusObj = new EmployStatusValidation();
export default {
    name: "EmployStatus",
    mounted() {
        EmployStatusObj.EmployStatusValidation();
        this.assignRights();
        this.getAllEmployStatus();
    },
    components: {
        paginate: Paginate,
    },
    data: () => ({
        menuRights: { allRights: {}, rightsForThisMenu: {} },
        menuId: Setting.MenuID.S_EmployeeStatus,
        dictEnum: dictEnum,
        EmployStatus: new EmployStatus(),
        isEditMode: false,
        EmployStatusList: [],
        selectAllEmployStatus: false,
        tempEmployStatusModel: new EmployStatus(),
    }),
    computed: {
        t() {
            return t;
        },
        user() {
            return this.$store.getters[StoreGetter.user];
        },
    },
    methods: {
        hasRight(key, menuId) {
            if (Object.keys(this.menuRights.allRights).length === 0) {
                return false;
            } else {
                return MenuRightSerivce.hasRightInMenu(
                    this.menuRights.allRights,
                    menuId ? menuId : this.menuId,
                    key
                );
            }
        },
        assignRights() {
            this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
            this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
                x => x.MenuID == this.menuId
            );
        },
        async getAllEmployStatus() {
            var self = this;
            var obj = {}
            const response = await StaffEmploymentService.getAllEmployStatus(obj);
            if (response.data.IsSuccess) {
                self.EmployStatusList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        selectAllEmployStatusRecord: function () {
            var self = this;
            var IsSelected = self.selectAllEmployStatus;
            self.EmployStatusList.forEach(function (val, index) {
                val["isSelected"] = IsSelected;
            });
        },
        deleteMultipleEmployStatusPopup: function () {
            var arrayList = [];
            var self = this;
            self.EmployStatusList.forEach(function (key, value) {
                if (key.isSelected) {
                    arrayList.push(key);
                }
            });
            if (arrayList.length > 0) {
                $('#deleteEmployStatusListModel').modal('show');
            }
            else {
                SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectDeleteRecord));
            }
        },
        async deleteMultipleEmployStatus() {
            var arrayList = [];
            var self = this;
            $('#deleteEmployStatusListModel').modal('hide');
            self.EmployStatusList.forEach(function (key, value) {
                if (key.isSelected) {
                    arrayList.push(key);
                }
            });
            const obj = {
                empStatusList: arrayList,
            };
            const response = await StaffEmploymentService.deleteEmployStatus(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetEmployStatus();
                await self.getAllEmployStatus();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        OnEmployStatusSelect: function (model) {
            this.tempEmployStatusModel = model;
        },
        addEmployStatus: function () {
            var self = this;
            $('#EmployStatusModel').modal('show');
            self.isEditMode = false;
            self.EmployStatus = new EmployStatus();
            self.$validator.reset();
            self.vErrors.clear();
        },
        async saveEmployStatusDetail(obj) {
            var self = this;
            const response = await StaffEmploymentService.addEmployStatus(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetEmployStatus();
                await self.getAllEmployStatus();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        async editEmployStatus(obj) {
            var self = this;
            const response = await StaffEmploymentService.updateEmployStatus(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetEmployStatus();
                await self.getAllEmployStatus();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        async saveEmployStatus() {
            var self = this;
            self.$validator.validateAll().then(result => {
                if (result) {
                    $('#EmployStatusModel').modal('hide');
                    const obj = {
                        model: {
                            EmpStatus: self.EmployStatus.EmpStatus,
                            CDesc: self.EmployStatus.CDesc,
                            EDesc: self.EmployStatus.EDesc,
                        }
                    };
                    if (self.isEditMode) {
                        self.editEmployStatus(obj);
                    }
                    else {
                        self.saveEmployStatusDetail(obj);
                    }
                }
            });
        },
        async editEmployStatusDetail() {
            var self = this;
            self.isEditMode = true;
            if (self.tempEmployStatusModel.EmpStatus != "") {
                self.EmployStatus = this.tempEmployStatusModel;
                self.$validator.reset();
                self.vErrors.clear();
                $('#EmployStatusModel').modal('show');
            }
            else {
                SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectEditRecord));
            }
        },
        resetEmployStatus: function () {
            var self = this;
            self.selectAllEmployStatus = false;
            self.isEditMode = false;
            self.EmployStatus = new EmployStatus();
            self.tempEmployStatusModel = new EmployStatus();
            self.$validator.reset();
            self.vErrors.clear();
        },
        closeEmployStatusPopup: function () {
            var self = this;
            self.selectAllEmployStatus = false;
            self.isEditMode = false;
            self.EmployStatus = new EmployStatus();
            self.tempEmployStatusModel = new EmployStatus();
            self.$validator.reset();
            self.vErrors.clear();
            $('#EmployStatusModel').modal('hide');
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S081700-EmployStatus/S081700-EmployStatus.js